'use strict';
define(['angular', 'components/st-keyword-trend/trend-bars'], function (angular, buildTrendBars) {
    function Controller($scope, $translate, $mdToast, $location, $filter, LanguageService, GoogleAdsService,
                        KeywordListService, AuthService) {
        var vm = $scope;
        var PAGE_SIZE = 50;
        var LANGUAGE_FLAGS = {1004: 'IT', 1000: 'GB', 1001: 'DE', 1002: 'FR', 1003: 'ES'};
        var COUNTRY_FLAGS = {
            2380: 'IT', 2840: 'US', 2826: 'GB', 2276: 'DE', 2250: 'FR', 2724: 'ES',
            2620: 'PT', 2528: 'NL', 2056: 'BE', 2756: 'CH', 2040: 'AT', 2372: 'IE',
            2752: 'SE', 2578: 'NO', 2208: 'DK', 2246: 'FI', 2616: 'PL', 2203: 'CZ',
            2300: 'GR', 2642: 'RO', 2348: 'HU', 2124: 'CA', 2484: 'MX', 2076: 'BR',
            2032: 'AR', 2036: 'AU', 2554: 'NZ', 2392: 'JP', 2410: 'KR', 2156: 'CN',
            2356: 'IN', 2702: 'SG', 2784: 'AE', 2792: 'TR', 2710: 'ZA'
        };
        var DEFAULTS_BY_LANGUAGE = {
            it: {language: 'Italian', location: 'Italy'},
            en: {language: 'English', location: 'United States'},
            de: {language: 'German', location: 'Germany'},
            fr: {language: 'French', location: 'France'},
            es: {language: 'Spanish', location: 'Spain'},
            pl: {language: 'English', location: 'Poland'}
        };
        /* question words of the supported languages, used by the "questions" tab */
        var QUESTION_WORDS = [
            'come', 'cosa', 'quando', 'dove', 'perché', 'perche', 'quale', 'chi', 'quanto',
            'how', 'what', 'when', 'where', 'why', 'which', 'who', 'how much',
            'wie', 'was', 'wann', 'wo', 'warum', 'welche', 'wie viel',
            'comment', 'quoi', 'quand', 'pourquoi', 'quel', 'combien',
            'cómo', 'como', 'qué', 'que', 'cuándo', 'cuando', 'dónde', 'donde', 'por qué', 'cuál', 'cuánto', 'cuanto'
        ];
        var STOP_WORDS = [
            'the', 'and', 'for', 'with', 'you', 'your', 'are', 'was', 'how', 'what', 'who',
            'di', 'del', 'della', 'che', 'per', 'con', 'una', 'uno', 'gli', 'dei', 'non',
            'der', 'die', 'das', 'und', 'für', 'mit', 'les', 'des', 'une', 'pour', 'avec',
            'los', 'las', 'una', 'para', 'con', 'por'
        ];

        vm.loading = false;
        vm.error = null;
        vm.partial = false;
        vm.currencyCode = null;
        vm.hasResults = false;
        vm.total = 0;
        vm.allKeywords = [];
        vm.results = [];
        vm.rows = [];
        vm.page = 0;
        vm.pageSize = PAGE_SIZE;
        vm.pages = 0;
        vm.sortBy = 'monthlySearches';
        vm.sortDescending = true;
        vm.tab = 'all';
        vm.group = null;
        vm.groupSort = 'count';
        vm.groupLimit = 15;
        vm.selectedCount = 0;
        vm.resultQuery = '';
        var requestedCountryCode = null;
        vm.selectLanguage = selectLanguage;
        vm.selectLocation = selectLocation;
        /* Search box of the language / country menus. */
        vm.pickerSearch = {language: '', location: ''};
        vm.pickerItems = pickerItems;
        vm.pickerEmpty = pickerEmpty;
        vm.selection = {
            language: null,
            location: null
        };
        vm.keywordListOptions = {
            template: 3,
            createAKeywordList: createAKeywordList,
            addQueriesToKeywordlist: addQueriesToKeywordlist,
            getAllKeywordList: getAllKeywordList,
            buttonDisabled: true,
            queriesSelected: [],
            class: 'st-ga__button st-ga__button--outline st-ga__button--sm',
            position: '0 0'
        };
        vm.filters = {
            include: '',
            exclude: ''
        };
        vm.groups = [];
        vm.stats = {
            keywords: 0,
            volume: 0,
            competition: 0
        };
        vm.query = {
            keywords: '',
            network: 'GOOGLE_SEARCH',
            seedType: 'keyword'
        };
        vm.seedLabelKey = 'googleads.keywords.label';
        vm.seedPlaceholderKey = 'googleads.keywords.placeholder';
        vm.seedHintKey = 'googleads.keywords.hint';
        vm.referenceData = {
            languages: [],
            locations: [],
            networks: [],
            seedTypes: [],
            matchTypes: [],
            depths: []
        };
        vm.tabs = ['all', 'questions', 'broad', 'phrase', 'exact', 'related'];
        vm.matchOptions = vm.tabs.map(function (value) {
            return {value: value, label: 'googleads.tab.' + value};
        });
        vm.seedOptions = [
            {value: 'keyword', label: 'googleads.seed.keyword'},
            {value: 'domain', label: 'googleads.seed.domain'}
        ];

        vm.search = search;
        vm.startResearchFromTable = startResearchFromTable;
        vm.focusKeywordInput = focusKeywordInput;
        vm.setSort = setSort;
        vm.setSeedType = setSeedType;
        vm.setTab = setTab;
        vm.setGroup = setGroup;
        vm.setFilters = setFilters;
        vm.clearFilters = clearFilters;
        vm.nextPage = nextPage;
        vm.previousPage = previousPage;
        vm.exportCsv = exportCsv;
        vm.competitionClass = competitionClass;
        vm.competitionLabel = competitionLabel;
        vm.difficultyClass = difficultyClass;
        vm.formatCurrency = formatCurrency;
        vm.canSearch = canSearch;
        vm.updateSelection = updateSelection;
        vm.isPageSelected = function () {
            return vm.rows.length > 0 && vm.rows.every(function (row) { return row.selected; });
        };
        vm.togglePageSelection = function () {
            var selected = !vm.isPageSelected();
            vm.rows.forEach(function (row) { row.selected = selected; });
            updateSelection();
        };

        var researchStateKeys = ['loading', 'error', 'partial', 'currencyCode', 'hasResults', 'total', 'allKeywords',
            'results', 'rows', 'page', 'pages', 'sortBy', 'sortDescending', 'tab', 'group',
            'groupSort', 'groupLimit', 'selectedCount', 'resultQuery', 'selection', 'filters',
            'groups', 'stats', 'query'];
        var emptyResearchState = angular.copy(captureResearchState());
        var nextResearchId = 1;
        vm.researchTabs = [{id: nextResearchId++, label: $translate.instant('googleads.title')}];
        vm.activeResearchId = vm.researchTabs[0].id;
        vm.openKeywordResearch = openKeywordResearch;
        vm.activateResearch = activateResearch;
        vm.closeResearch = closeResearch;

        function captureResearchState() {
            var state = {};
            researchStateKeys.forEach(function (key) { state[key] = vm[key]; });
            return state;
        }

        function currentResearch() {
            return vm.researchTabs.filter(function (item) { return item.id === vm.activeResearchId; })[0];
        }

        function activateResearch(item) {
            if (vm.loading || item.id === vm.activeResearchId) { return; }
            currentResearch().state = captureResearchState();
            vm.activeResearchId = item.id;
            researchStateKeys.forEach(function (key) { vm[key] = item.state[key]; });
            refreshInputKeys();
            updateSelection();
        }

        function researchKey(keyword, seedType, selection, network) {
            return JSON.stringify([
                String(keyword).trim().replace(/\s+/g, ' ').toLowerCase(),
                seedType,
                String(selection.language && selection.language.id),
                String(selection.location && selection.location.id),
                network
            ]);
        }

        function openKeywordResearch(keyword) {
            if (vm.loading || !keyword) { return; }
            var key = researchKey(keyword, 'keyword', vm.selection, vm.query.network);
            var existing = vm.researchTabs.filter(function (item) { return item.key === key; })[0];
            if (existing) {
                activateResearch(existing);
                return;
            }
            var context = angular.copy(vm.selection);
            var network = vm.query.network;
            var item = {id: nextResearchId++, label: keyword, state: angular.copy(emptyResearchState)};
            item.state.selection = context;
            item.state.query = {keywords: keyword, seedType: 'keyword', network: network};
            vm.researchTabs.push(item);
            activateResearch(item);
            search();
        }

        function closeResearch(item, event) {
            event.stopPropagation();
            if (vm.loading || vm.researchTabs.length === 1) { return; }
            var index = vm.researchTabs.indexOf(item);
            if (item.id === vm.activeResearchId) {
                activateResearch(vm.researchTabs[index > 0 ? index - 1 : 1]);
            }
            vm.researchTabs.splice(index, 1);
        }

        init();

        /**
         * Loads the reference data and runs the lookup when the tool is opened with ?keyword=
         */
        function init() {
            var params = $location.search();

            if (params.keyword) {
                vm.query.keywords = params.keyword;
            }

            if (['keyword', 'domain'].indexOf(params.typeOfResearch) !== -1) {
                vm.query.seedType = params.typeOfResearch;
            } else if (['keyword', 'domain'].indexOf(params.seedType) !== -1) {
                vm.query.seedType = params.seedType;
            }
            /* Public links use `countryCode` (e.g. US). `mode` is deprecated
               and intentionally ignored. */
            requestedCountryCode = params.countryCode || null;

            if (vm.tabs.indexOf(params.tab) !== -1) {
                vm.tab = params.tab;
            }

            refreshInputKeys();

            loadReferenceData()
                .then(function () {
                    if (params.keyword) {
                        search();
                    }
                });
        }

        /**
         * @returns {Promise}
         */
        function loadReferenceData() {
            return GoogleAdsService.getReferenceData()
                .then(function (res) {
                    var data = (res && res.data) || {};

                    vm.referenceData = {
                        languages: withFlags(data.languages || [], LANGUAGE_FLAGS),
                        locations: withFlags(data.locations || [], COUNTRY_FLAGS),
                        networks: data.networks || [],
                        seedTypes: data.seedTypes || [],
                        matchTypes: data.matchTypes || [],
                        depths: data.depths || []
                    };

                    applyDefaultFilters();
                })
                .catch(function (err) {
                    console.log(err);
                    showError(getErrorMessage(err));
                });
        }

        /**
         * Pre-selects language and location based on the language used in the suite.
         */
        function applyDefaultFilters() {
            var code = (LanguageService.getCodeAndCountrySaveOnStorage() || '').substring(0, 2).toLowerCase();
            var defaults = DEFAULTS_BY_LANGUAGE[code] || DEFAULTS_BY_LANGUAGE.en;

            vm.selection.language = findByName(vm.referenceData.languages, defaults.language)
                || vm.referenceData.languages[0]
                || null;

            vm.selection.location = findByName(vm.referenceData.locations, defaults.location)
                || vm.referenceData.locations[0]
                || null;
            var requestedLocation = locationByCountryCode(requestedCountryCode);
            if (requestedLocation) {
                vm.selection.location = requestedLocation;
            }
        }

        function locationByCountryCode(code) {
            var wanted = String(code || '').toUpperCase();
            if (!wanted) return null;
            for (var i = 0; i < vm.referenceData.locations.length; i++) {
                var item = vm.referenceData.locations[i];
                if (String(COUNTRY_FLAGS[item.id] || '').toUpperCase() === wanted) {
                    return item;
                }
            }
            return null;
        }

        function withFlags(items, countries) {
            return items.map(function (item) {
                var code = countries[item.id];
                /* Real flag images instead of emoji: the template loads
                   ../assets/img/modules/flags/{flag}.png */
                return angular.extend({}, item, {
                    flag: code ? code.toLowerCase() : null,
                    displayName: item.name
                });
            });
        }

        function selectLanguage(item) {
            vm.selection.language = item;
        }

        function selectLocation(item) {
            vm.selection.location = item;
        }

        /* Language and country are long lists: the menus carry their own search
           box, which filters on the visible name. */
        function pickerItems(items, query) {
            var term = String(query || '').trim().toLowerCase();
            if (!term) return items || [];
            return (items || []).filter(function (item) {
                return String(item && item.name || '').toLowerCase().indexOf(term) >= 0;
            });
        }

        function pickerEmpty(items, query) {
            return pickerItems(items, query).length === 0;
        }

        function findByName(list, name) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].name === name) {
                    return list[i];
                }
            }

            return null;
        }

        /**
         * Switches between a keyword seed and a domain seed.
         * @param {string} seedType
         */
        function setSeedType(seedType) {
            if (vm.query.seedType === seedType) {
                return;
            }

            vm.query.seedType = seedType;
            refreshInputKeys();
            clearResults();
        }

        /**
         * Keeps the input label, placeholder and hint aligned with the selected seed type.
         */
        function refreshInputKeys() {
            var isDomain = vm.query.seedType === 'domain';

            vm.seedLabelKey = isDomain ? 'googleads.input.domain.label' : 'googleads.keywords.label';
            vm.seedPlaceholderKey = isDomain ? 'googleads.input.domain.placeholder' : 'googleads.keywords.placeholder';
            vm.seedHintKey = isDomain ? 'googleads.input.domain.hint' : 'googleads.keywords.hint';
        }

        /**
         * @returns {boolean}
         */
        function canSearch() {
            return !!vm.query.keywords
                && !!vm.selection.language
                && !!vm.selection.location
                && !vm.loading
                && (vm.query.seedType !== 'domain' || isValidDomain(vm.query.keywords));
        }

        /**
         * @param {string} value
         * @returns {boolean} true for a full url or a bare domain (with optional path)
         */
        function isValidDomain(value) {
            var seed = String(value || '').trim();

            return /^https?:\/\/[^\s]+$/i.test(seed)
                || /^[a-z0-9-]+(\.[a-z0-9-]+)+(\/[^\s]*)?$/i.test(seed);
        }

        function search() {
            if (vm.loading) {
                return;
            }

            if (!vm.query.keywords || !vm.selection.language || !vm.selection.location) {
                showError($translate.instant('googleads.error.required'));
                return;
            }

            if (vm.query.seedType === 'domain' && !isValidDomain(vm.query.keywords)) {
                showError($translate.instant('googleads.error.domain'));
                return;
            }

            currentResearch().key = researchKey(vm.query.keywords, vm.query.seedType, vm.selection, vm.query.network);
            currentResearch().label = vm.query.keywords;
            vm.loading = true;
            clearResults();
            var submittedQuery = vm.query.keywords;

            /* the whole set is downloaded once and filtered here: switching tab is instant */
            GoogleAdsService.getKeywordIdeas({
                keywords: vm.query.keywords,
                seedType: vm.query.seedType,
                matchType: 'all',
                language: vm.selection.language.id,
                location: vm.selection.location.id,
                network: vm.query.network
            })
                .then(function (res) {
                    vm.loading = false;

                    var data = (res && res.data) || {};

                    /* the trend is precomputed here: an array built inside the template
                       would make ng-repeat dirty on every digest */
                    vm.allKeywords = (data.keywords || []).map(function (keyword) {
                        keyword.trendBars = buildTrendBars(keyword);

                        return keyword;
                    });
                    vm.partial = !!data.partial;
                    vm.currencyCode = data.currencyCode || null;
                    vm.resultQuery = submittedQuery;
                    vm.hasResults = true;

                    applyFilters();
                })
                .catch(function (err) {
                    vm.loading = false;
                    console.log(err);
                    showError(getErrorMessage(err));
                });
        }

        function startResearchFromTable() {
            if (canSearch()) {
                search();
                return;
            }
            focusKeywordInput();
        }

        function focusKeywordInput() {
            var input = document.getElementById('st-ga-keywords');
            if (!input) {
                return;
            }
            if (input.scrollIntoView) {
                input.scrollIntoView({behavior: 'smooth', block: 'center'});
            }
            input.focus();
        }

        /**
         * Applies tab, include/exclude and group filters, then sorts and paginates.
         */
        function applyFilters() {
            var seeds = splitSeeds();
            var tabFiltered = vm.allKeywords.filter(function (keyword) {
                return matchTab(keyword, seeds);
            });

            var matching = tabFiltered.filter(function (keyword) {
                return matchTextFilters(keyword)
                    && (vm.filters.volumeMin == null || keyword.monthlySearches >= vm.filters.volumeMin)
                    && (vm.filters.volumeMax == null || keyword.monthlySearches <= vm.filters.volumeMax)
                    && (vm.filters.competitionMax == null || keyword.competitionIndex <= vm.filters.competitionMax);
            });
            vm.groups = buildGroups(matching, seeds);
            vm.groupTotal = matching.length;
            var filtered = matching.filter(matchGroup);

            vm.results = filtered;
            vm.total = filtered.length;
            vm.stats = buildStats(filtered);
            updateSelection();

            applySort();
        }

        /**
         * @returns {string[]} the seeds typed by the user
         */
        function splitSeeds() {
            return String(vm.resultQuery || vm.query.keywords || '')
                .split(/[\n,;]+/)
                .map(function (keyword) {
                    return keyword.trim().toLowerCase();
                })
                .filter(function (keyword) {
                    return !!keyword;
                });
        }

        /**
         * Semrush-like match types.
         * @param {Object} row
         * @param {string[]} seeds
         * @returns {boolean}
         */
        function matchTab(row, seeds) {
            var keyword = row.keyword.toLowerCase();

            switch (vm.tab) {
            case 'exact':
                return seeds.indexOf(keyword) !== -1;
            case 'phrase':
                return containsAny(keyword, seeds);
            case 'broad':
                return seeds.some(function (seed) {
                    return words(seed).every(function (word) {
                        return keyword.indexOf(word) !== -1;
                    });
                });
            case 'questions':
                return isQuestion(keyword);
            case 'related':
                return !containsAny(keyword, seeds);
            default:
                return true;
            }
        }

        function containsAny(keyword, seeds) {
            return seeds.some(function (seed) {
                return keyword.indexOf(seed) !== -1;
            });
        }

        function words(value) {
            return String(value || '').split(/\s+/).filter(function (word) {
                return word.length > 1;
            });
        }

        function isQuestion(keyword) {
            if (keyword.indexOf('?') !== -1) {
                return true;
            }

            /* the question word can be anywhere ("consulenza seo quanto costa") */
            return QUESTION_WORDS.some(function (word) {
                return new RegExp('(^|[^a-z\\u00e0-\\u00ff])'
                    + word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                    + '([^a-z\\u00e0-\\u00ff]|$)').test(keyword);
            });
        }

        /**
         * @param {Object} row
         * @returns {boolean} include/exclude filters
         */
        function matchTextFilters(row) {
            var keyword = row.keyword.toLowerCase();

            return terms(vm.filters.include).every(function (term) {
                return keyword.indexOf(term) !== -1;
            }) && !terms(vm.filters.exclude).some(function (term) {
                return keyword.indexOf(term) !== -1;
            });
        }

        function matchGroup(row) {
            return !vm.group || row.keyword.toLowerCase().indexOf(vm.group) !== -1;
        }

        /**
         * @param {string} value
         * @returns {string[]} lowercase terms
         */
        function terms(value) {
            return String(value || '')
                .split(',')
                .map(function (term) {
                    return term.trim().toLowerCase();
                })
                .filter(function (term) {
                    return !!term;
                });
        }

        /**
         * Groups the keywords by their most frequent words (Semrush-like left panel).
         * @param {Object[]} keywords
         * @param {string[]} seeds
         * @returns {Object[]} [{word, count}]
         */
        function buildGroups(keywords, seeds) {
            var seedWords = [];

            seeds.forEach(function (seed) {
                seedWords = seedWords.concat(words(seed));
            });

            var counters = Object.create(null);

            keywords.forEach(function (row) {
                words(row.keyword.toLowerCase()).filter(function (word, index, list) {
                    return list.indexOf(word) === index;
                }).forEach(function (word) {
                    if (word.length < 3 || seedWords.indexOf(word) !== -1 || STOP_WORDS.indexOf(word) !== -1) {
                        return;
                    }

                    counters[word] = counters[word] || {count: 0, volume: 0};
                    counters[word].count += 1;
                    counters[word].volume += row.monthlySearches || 0;
                });
            });

            return Object.keys(counters)
                .map(function (word) {
                    return {word: word, count: counters[word].count, volume: counters[word].volume};
                })
                .sort(function (a, b) {
                    return b.count - a.count;
                });
        }

        /**
         * @param {Object[]} keywords
         * @returns {Object} totals shown above the table
         */
        function buildStats(keywords) {
            var volume = 0;
            var competition = 0;

            keywords.forEach(function (row) {
                volume += row.monthlySearches || 0;
                competition += row.competitionIndex || 0;
            });

            return {
                keywords: keywords.length,
                volume: volume,
                competition: keywords.length ? Math.round(competition / keywords.length) : 0
            };
        }

        /**
         * @param {string} tab
         */
        function setTab(tab) {
            vm.tab = tab;
            vm.page = 0;
            applyFilters();
        }

        /**
         * @param {string} word
         */
        function setFilters() {
            vm.page = 0;
            applyFilters();
        }

        /**
         * @param {string} word
         */
        function setGroup(word) {
            vm.group = vm.group === word ? null : word;
            vm.page = 0;
            applyFilters();
        }

        function clearFilters() {
            vm.group = null;
            vm.filters.include = '';
            vm.filters.exclude = '';
            vm.filters.volumeMin = null;
            vm.filters.volumeMax = null;
            vm.filters.competitionMax = null;
            vm.page = 0;
            applyFilters();
        }

        /**
         * Sorts the results and refreshes the current page.
         */
        function applySort() {
            var field = vm.sortBy;
            var descending = vm.sortDescending ? -1 : 1;

            vm.results.sort(function (a, b) {
                if (typeof a[field] === 'string') {
                    return a[field].localeCompare(b[field]) * descending;
                }

                return (a[field] - b[field]) * descending;
            });

            vm.pages = Math.ceil(vm.results.length / vm.pageSize);
            setPage(vm.page);
        }

        /**
         * @param {string} field
         */
        function setSort(field) {
            if (vm.sortBy === field) {
                vm.sortDescending = !vm.sortDescending;
            } else {
                vm.sortBy = field;
                vm.sortDescending = true;
            }

            applySort();
        }

        /**
         * @param {number} page
         */
        function setPage(page) {
            vm.page = Math.min(Math.max(page, 0), Math.max(vm.pages - 1, 0));

            var start = vm.page * vm.pageSize;
            vm.rows = vm.results.slice(start, start + vm.pageSize);
        }

        function nextPage() {
            setPage(vm.page + 1);
        }

        function previousPage() {
            setPage(vm.page - 1);
        }

        function clearResults() {
            vm.selectedCount = 0;
            vm.resultQuery = '';
            vm.groupLimit = 15;
            vm.error = null;
            vm.partial = false;
            vm.currencyCode = null;
            vm.hasResults = false;
            vm.total = 0;
            vm.allKeywords = [];
            vm.results = [];
            vm.rows = [];
            vm.groups = [];
            vm.group = null;
            vm.page = 0;
            vm.pages = 0;
            vm.stats = {
                keywords: 0,
                volume: 0,
                competition: 0
            };
            updateSelection();
        }

        /**
         * @param {Object} row
         * @returns {string} css modifier for the competition badge
         */
        function competitionClass(row) {
            var competition = (row.competition || 'UNKNOWN').toLowerCase();

            return ['low', 'medium', 'high'].indexOf(competition) !== -1 ? competition : 'unknown';
        }

        /**
         * @param {Object} row
         * @returns {string} translated competition label
         */
        function competitionLabel(row) {
            return $translate.instant('googleads.competition.' + competitionClass(row));
        }

        function difficultyClass(row) {
            var score = Number(row.difficulty);
            if (!score) return 'unknown';
            if (score >= 70) return 'high';
            if (score >= 30) return 'medium';
            return 'low';
        }

        function formatCurrency(value) {
            if (value === null || value === undefined || value === '') return '—';
            var symbols = {
                USD: '$', EUR: '€', GBP: '£', CAD: 'C$', AUD: 'A$', BRL: 'R$', MXN: 'MX$',
                JPY: '¥', INR: '₹', CHF: 'CHF ', SEK: 'kr ', NOK: 'kr ', DKK: 'kr ',
                PLN: 'zł ', CZK: 'Kč ', RON: 'lei ', HUF: 'Ft ', TRY: '₺', ZAR: 'R',
                AED: 'AED ', SGD: 'S$', NZD: 'NZ$', KRW: '₩', CNY: '¥', HKD: 'HK$',
                ILS: '₪', THB: '฿', VND: '₫', UAH: '₴', RUB: '₽'
            };
            var code = String(vm.currencyCode || '').toUpperCase();
            if (!code) return $filter('number')(value, 2);
            return $filter('currency')(value, symbols[code] || (code + ' '), 2);
        }

        /**
         * Exports the filtered results (already sorted) as CSV.
         */
        function exportCsv() {
            if (!vm.results.length) {
                return;
            }

            var exportRows = vm.selectedCount ? vm.results.filter(function (row) { return row.selected; }) : vm.results;
            var months = (exportRows[0].trendBars || []).map(function (bar) {
                return bar.label;
            });

            var lines = [[
                $translate.instant('googleads.column.keyword'),
                $translate.instant('googleads.column.volume'),
                $translate.instant('googleads.column.competition'),
                $translate.instant('googleads.column.competitionIndex'),
                $translate.instant('googleads.column.difficulty'),
                $translate.instant('googleads.column.bidLow'),
                $translate.instant('googleads.column.bidHigh')
            ].concat(months)];

            exportRows.forEach(function (row) {
                var volumes = (row.trendBars || []).map(function (bar) {
                    return bar.searches;
                });

                lines.push([
                    row.keyword,
                    row.monthlySearches,
                    row.competition,
                    row.competitionIndex,
                    row.difficulty,
                    row.lowTopOfPageBid,
                    row.highTopOfPageBid
                ].concat(volumes));
            });

            downloadCsv(lines, 'google-ads-keyword-planner.csv');
        }

        function updateSelection() {
            var selected = vm.results.filter(function (row) { return row.selected; });
            vm.selectedCount = selected.length;
            vm.keywordListOptions.queriesSelected = selected.map(formatKeywordListQuery);
            vm.keywordListOptions.buttonDisabled = !selected.length;
        }

        /**
         * Country used by Google Ads for the current research.
         * @returns {string} ISO alpha-2 code
         */
        function selectedCountryCode() {
            var location = vm.selection.location || {};
            var code = COUNTRY_FLAGS[Number(location.id)] || location.flag || 'US';
            return String(code).toUpperCase();
        }

        /**
         * Maps a Google Ads row to the query shape used by Keyword List Manager.
         * @param {Object} row
         * @returns {Object}
         */
        function formatKeywordListQuery(row) {
            var lowBid = Number(row.lowTopOfPageBid) || 0;
            var highBid = Number(row.highTopOfPageBid) || 0;
            return {
                keyword: row.keyword,
                countryCode: selectedCountryCode(),
                searchEngineId: 1,
                deviceId: 1,
                monthlySearches: row.monthlySearches,
                avgVolume: row.monthlySearches,
                avgCpc: lowBid && highBid ? (lowBid + highBid) / 2 : (lowBid || highBid || null),
                avgCompetition: row.competitionIndex,
                lowTopOfPageBid: row.lowTopOfPageBid,
                highTopOfPageBid: row.highTopOfPageBid,
                competitionIndex: row.competitionIndex,
                difficulty: row.difficulty,
                monthlySearchVolumes: row.monthlySearchVolumes || []
            };
        }

        function getAllKeywordList() {
            if (!AuthService.isAuthenticated()) {
                return Promise.resolve({data: {rows: []}});
            }
            return KeywordListService.getAllKeywordList();
        }

        function createAKeywordList(name) {
            if (!name) {
                return Promise.reject(new Error('Invalid list name'));
            }
            return KeywordListService.createAKeywordList({
                name: name,
                toolSourceId: 1
            }).then(function () {
                return getAllKeywordList();
            });
        }

        function addQueriesToKeywordlist(queriesSelected, keywordListId) {
            return KeywordListService.addGoogleAdsQueries(keywordListId, queriesSelected)
                .then(function () {
                    return getAllKeywordList();
                });
        }

        /**
         * @param {Array[]} lines
         * @param {string} fileName
         */
        function downloadCsv(lines, fileName) {
            var csv = lines.map(function (cells) {
                return cells.map(function (cell) {
                    var value = cell === null || cell === undefined ? '' : String(cell);

                    return '"' + value.replace(/"/g, '""') + '"';
                }).join(';');
            }).join('\n');

            var link = document.createElement('a');
            var blob = new Blob(['\ufeff' + csv], {type: 'text/csv;charset=utf-8;'});

            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        }

        /**
         * @param {Object} err
         * @returns {string}
         */
        function getErrorMessage(err) {
            var defaultMessage = $translate.instant('googleads.error');

            try {
                if (err.data.error.code === 'QUOTA_EXCEEDED') {
                    return $translate.instant('googleads.error.quota');
                }

                return err.data.error.message || defaultMessage;
            } catch (e) {
                return defaultMessage;
            }
        }

        /**
         * @param {string} message
         */
        function showError(message) {
            vm.error = message;

            $mdToast.show({
                template: '<md-toast layout="row" flex class="md-toast">' +
                    '   <div><i class="icon-caution st-err m-r-sm"></i></div>' +
                    '   <div>' + message + '</div>' +
                    '</md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }
    }

    Controller.$inject = ['$scope', '$translate', '$mdToast', '$location', '$filter', 'LanguageService',
        'GoogleAdsService', 'KeywordListService', 'AuthService'];
    return Controller;
});
